import React from 'react';
import { FaStar, FaCodeBranch, FaGithub, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  return (
    <div className="bg-white/90 backdrop-blur-md rounded-2xl p-6 border border-white/50 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 flex flex-col h-full group">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary-600 transition-colors">
          {project.title}
        </h3>
        <span className={`px-2 py-1 rounded-lg text-xs font-bold uppercase tracking-wider ${
            project.difficulty === 'Beginner' ? 'bg-green-100 text-green-700' :
            project.difficulty === 'Intermediate' ? 'bg-yellow-100 text-yellow-700' :
            'bg-red-100 text-red-700'
        }`}>
            {project.difficulty}
        </span>
      </div>

      <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed">
        {project.description}
      </p>

      <div className="flex flex-wrap gap-2 mb-6">
        {project.tags.slice(0, 3).map((tag, index) => (
          <span key={index} className="px-2 py-1 bg-gray-100 text-gray-600 rounded-md text-xs font-medium">
            {tag}
          </span>
        ))}
        {project.tags.length > 3 && (
            <span className="px-2 py-1 bg-gray-50 text-gray-400 rounded-md text-xs font-medium">+{project.tags.length - 3}</span>
        )}
      </div>

      <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
        <div className="flex space-x-4 text-gray-500 text-sm">
          <div className="flex items-center space-x-1">
            <FaStar className="text-yellow-400" />
            <span>{project.stars}</span>
          </div>
          <div className="flex items-center space-x-1">
            <FaCodeBranch className="text-gray-400" />
            <span>{project.forks}</span>
          </div>
        </div>
        
        <Link 
            to={`/open-source/${project.id}`}
            className="flex items-center space-x-2 text-primary-600 font-bold text-sm hover:underline"
        >
            <span>View Details</span>
            <FaArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;
